module.exports = __webpack_public_path__ + "img/co2.931c5012.png";